import { render, staticRenderFns } from "./CourseHeader.vue?vue&type=template&id=735b356e&scoped=true&"
import script from "./CourseHeader.vue?vue&type=script&lang=js&"
export * from "./CourseHeader.vue?vue&type=script&lang=js&"
import style0 from "./CourseHeader.vue?vue&type=style&index=0&id=735b356e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b356e",
  null
  
)

export default component.exports